export const RETRIEVE_PROJECT_LIST_PENDING = 'RETRIEVE_PROJECT_LIST_PENDING';
export const RETRIEVE_PROJECT_LIST_SUCCESS = 'RETRIEVE_PROJECT_LIST_SUCCESS';
export const RETRIEVE_PROJECT_LIST_FAILURE = 'RETRIEVE_PROJECT_LIST_FAILURE';
